<template>
  <div class="details">
    <info-panel :padding="24">
      <div class="title">
        正在使用中
      </div>
      <el-row>
        <el-col
          :span="col"
          class="using"
        >
          <div
            v-for="item in result"
            v-if="item.isShow"
            :key="item.rank"
            class="item"
          >
            {{ item.supportMobilePhone }}
            <!-- <svg-icon name="close" /> -->
          </div>
        </el-col>
      </el-row>
      <div class="title add-form">
        <el-button
          type="primary"
          @click="add"
        >
          新增号码
        </el-button>
      </div>
      <el-row>
        <el-col
          :span="col"
          class="no-using"
        >
          <div
            v-for="(item,index) in result"
            :key="item.rank"
            class="item"
            :class="{'is-check':item.isShow}"
          >
            <el-checkbox v-model="item.isShow" />
            <el-input
              v-model="item.supportMobilePhone"
              class="input-name"
            />
            <svg-icon
              name="close"
              @click.native="deleteItem(index)"
            />
          </div>
        </el-col>
      </el-row>
    </info-panel>
    <el-row
      :gutter="20"
      class="submit"
    >
      <el-col class="btns">
        <el-button @click="cancel">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="submit"
        >
          保存
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import axClient from '@/services';

export default {
  name: 'HotSearch',
  components: {
    infoPanel,
  },
  data() {
    return {
      col: 18,
      result: {},
      data: {},
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    // 新增热搜
    add() {
      this.result.push({
        supportMobilePhone: '默认',
        rank: '',
        isShow: false,
      });
    },
    deleteItem(index) {
      this.result.splice(index, 1);
    },
    // 取消
    cancel() {
      // this.result = this._.cloneDeep(this.data);
      window.history.back();
    },
    // 保存
    async submit() {
      const form = this.result.map((v, i) => {
        if (v.isShow) { return Object.assign(v, { isShow: 1, rank: this.result.length - i }); }
        return Object.assign(v, { isShow: 0, rank: this.result.length - i });
      });
      const data = await axClient.config.updateSupportMobilePhone(form);
      if (data) {
        this.$message.success('编辑电话成功');
        this.getInfo();
      }
    },
    // 详情
    async getInfo() {
      const data = await axClient.config.listSupportMobilePhone();
      data.map((v) => {
        if (v.isShow === 1) { return Object.assign(v, { isShow: true }); }
        return Object.assign(v, { isShow: false });
      });
      this.result = data.sort((a, b) => b.rank - a.rank);
      this.data = JSON.stringify(this.result);
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  margin-top: 16px;
  .title {
    color: $--base-color-black;
    font-size: 14px;
    margin-bottom: 16px;
    font-weight: 500;
  }
  .submit {
    margin-top: 20px;
    text-align: center;
  }
  .add-form {
    margin-top: 16px;
  }
  .using {
    border: 0.5px solid rgba($--base-color-black, 0.3);
    border-radius: 8px;
    padding: 16px;
    background: #ffffff;
    .item {
      color: $--base-color-main;
      font-size: 14px;
      line-height: 14px;
      padding: 6px 15px 6px 15px;
      display: inline-flex;
      align-items: center;
      background: rgba($--base-color-main, 0.1);
      border-radius: 15px;
      margin-bottom: 15px;
      margin-right: 15px;
      svg {
        width: 10px;
        margin-left: 8px;
        cursor: pointer;
      }
    }
  }
  .no-using {
    border: 0.5px solid rgba($--base-color-black, 0.3);
    border-radius: 8px;
    padding: 16px;
    background: #ffffff;
    .item {
      display: inline-flex;
      align-items: center;
      margin-right: 25px;
      margin-bottom: 15px;
      font-size: 14px;
      line-height: 14px;
      background: #f7f7f7;
      padding: 8px 20px;
      &.is-check {
        color: $--base-color-main;
      }
      .input-name {
        margin-left: 10px;
       ::v-deep .el-input__inner{
          height: 24px;
          line-height: 24px;
          border-radius: 12px;
        }
      }
      svg {
        width: 18px;
        margin-left: 8px;
        cursor: pointer;
        color: $--base-color-black;
        padding: 4px;
        &:hover{
          background: rgba($--base-color-main, 1);
          color: #ffffff;
        }
      }
    }
  }
}
</style>